import { render, staticRenderFns } from "./billRecord.vue?vue&type=template&id=baa8181a&"
import script from "./billRecord.vue?vue&type=script&lang=js&"
export * from "./billRecord.vue?vue&type=script&lang=js&"
import style0 from "./billRecord.vue?vue&type=style&index=0&id=baa8181a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports